import { hasYesOrNo } from 'models/validate';
import legalAssociationsEnagedTerrorismValidator from 'forms/sections/legal/associations/engagedTerrorism/validators/item';
import { ValidateJSModel } from 'forms/shared/types';
import { LegalAssociationsEngagedTerrorismModel } from './types';

const legalAssociationsEngagedTerrorismValidator: ValidateJSModel<LegalAssociationsEngagedTerrorismModel> = {
  HasEngaged: { presence: true, hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasEngaged?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalAssociationsEnagedTerrorismValidator },
      };
    }

    return {};
  },
};

export default legalAssociationsEngagedTerrorismValidator;
